import kgDiceBackground from 'assets/images/graphical-header.jpeg';

export const DEFAULT_TITLE = 'KG Auction Hub';
export const HERO_BACKGROUND_ALT_TEXT = 'KG Auction House hero background';
export const KG_LOGO_ARIA_LABEL = 'Konrad Group Logo';
export const SETTINGS_ICON_ARIA_LABEL = 'Settings Icon';
export const LOGOUT_ICON_ARIA_LABEL = 'Logout Icon';
export const DEFAULT_IMAGE_BACKGROUND = kgDiceBackground;
export const LINK_TAB_INDEX = -1;
